<form [formGroup]="importForm" (ngSubmit)="submit()">
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.IMPORT_LABEL' | translate }}</label>
        <label class="file-upload btn btn--secondary icon i-upload">
            <input type="file" accept=".csv" (change)="onFileChange($event)" />
            {{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.IMPORT_BTN' | translate }}
        </label>
        <div *ngIf="fileControl.value">{{ fileControl.value?.name }}</div>
        <div class="success-message" *ngIf="uploaded">
            <p class="success">Fichier envoyé avec succès, pensez à vérifier vos mails pour être averti en cas d'erreur de traitement.</p>
        </div>
        <div class="error-messages" *ngIf="errorsUpload?.length">
            <p class="error">Erreur lors de l'envoi du fichier, veuillez réessayer ou contactez le support si le problème persiste.</p>
        </div>
    </div>
    <app-generic-button
        *ngIf="fileControl.value"
        [classes]="'btn--primary'"
        [inputText]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.IMPORT_BTN'"
        [type]="'submit'"
    ></app-generic-button>
</form>
